import type { SVGProps } from 'react';
const SvgFilter4 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#filter_4_svg__a)">
      <path
        fill="currentColor"
        d="M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5Zm12 10h2V5h-2v4h-2V5h-2v6h4v4Zm6-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2Zm0 16H7V3h14v14Z"
      />
    </g>
    <defs>
      <clipPath id="filter_4_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFilter4;
